import React__default from 'react';
import { isEmpty } from 'lodash';
import { VideoProvider } from '@invitae/cms-blocks';

var VideoNucleobaseProvider = function (_a) {
    var videoEvents = _a.videoEvents, children = _a.children;
    var areVideoEventsProvided = !isEmpty(videoEvents);
    if (!areVideoEventsProvided)
        return React__default.createElement(React__default.Fragment, null, children);
    return areVideoEventsProvided ? React__default.createElement(VideoProvider, { videoEvents: videoEvents }, children) : React__default.createElement(React__default.Fragment, null, children);
};

export { VideoNucleobaseProvider as default };
//# sourceMappingURL=VideoProvider.esm.js.map
